module.exports = __webpack_public_path__ + "media/common/images/badges/active/sekac-271e66344a4219ebd4449f8cae2224a9.svg";